var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "date-picker-group" }, [
    _c(
      "div",
      { staticClass: "start-date-picker" },
      [
        _c("el-date-picker", {
          staticStyle: { width: "100%" },
          attrs: {
            type: _vm.type,
            size: _vm.size,
            editable: false,
            placeholder: _vm.placeholder[0],
            "picker-options": _vm.startDateOptions,
            disabled: _vm.disabled,
          },
          on: { change: _vm.startDateChange },
          model: {
            value: _vm.startDate,
            callback: function ($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate",
          },
        }),
      ],
      1
    ),
    _c("span", [_vm._v(" - ")]),
    _c(
      "div",
      { staticClass: "end-date-picker" },
      [
        _c("el-date-picker", {
          staticStyle: { width: "100%" },
          attrs: {
            type: _vm.type,
            size: _vm.size,
            editable: false,
            placeholder: _vm.placeholder[1],
            "picker-options": _vm.endDateOptions,
            disabled: _vm.disabled,
          },
          on: { change: _vm.endDateChange },
          model: {
            value: _vm.endDate,
            callback: function ($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }